<script>
export default {
    name: 'MainComponent',
    methods: {
        openApple(){
            window.open('https://apps.apple.com/ru/app/myvpn/id6479427630', '_blank');
        },
        openAndroid(){
            ym(101875098,'reachGoal','chrome')
            // window.open('https://play.google.com/store/apps/details?id=ai.myvpn.app', '_blank')
            window.open('https://chromewebstore.google.com/detail/myvpn-proxy/lmkinhmkdpccgkhdhfmbpademifljdob?hl=ru&utm_source=ext_sidebar', '_blank')
            
        }},
    data() {
        return {
            platform:""
        }

    },
    computed: {
                utm_id() {
                  return this.$store.getters.utm
                },
                bot_url() {
                  return this.$store.getters.bot_url
                }
        },
        mounted() {
        }
}
</script>

<template>
    <div class="container">
        <div class="main-container" v-motion-fade>
            <h1 class="title title-big main-title">Надежный <span class="orange">VPN</span> всего за 399 ₽ в месяц</h1>
            <ul class="main-list">
                <li class="main-item text-medium fs-20"><img src="../assets/images/easy-reg-orange.svg" alt="logo">Без регистрации</li>
                <li class="main-item text-medium fs-20"><img src="../assets/images/megaphone-orange.svg" alt="logo">Без рекламы</li>
                <li class="main-item text-medium fs-20"><img src="../assets/images/eye-off-orange.svg" alt="logo">Без сбора данных</li>
            </ul>
            <button class="button orange-bg fs-28 orange-hover">
                <a @click="openAndroid" 
                    class="button-link">
                    Попробовать за 1₽
                </a>
            </button>
            <img class="main-img" src="../assets/images/main.png" alt="">
        </div>

    </div>
</template>

<style></style>